import React, { useState, useEffect } from 'react';

function TermsConditions() {
  const [activeSection, setActiveSection] = useState('');
  const [agreementAccepted, setAgreementAccepted] = useState(false);

  const sections = [
    { id: 'introduction', title: 'Giriş', icon: 'info' },
    { id: 'terms-of-use', title: 'İstifadə Şərtləri', icon: 'file' },
    { id: 'deposit-rules', title: 'Depozit Qaydaları', icon: 'dollar' },
    { id: 'auction-participation', title: 'Hərracda İştirak', icon: 'gavel' },
    { id: 'meeting-payment', title: 'Görüş və Ödəniş', icon: 'handshake' },
    { id: 'fake-listings', title: 'Saxta Elanlara Qarşı', icon: 'shield' },
    { id: 'buyer-withdrawal', title: 'Alıcının İmtinası', icon: 'cancel' },
    { id: 'seller-rules', title: 'Satıcı Qaydaları', icon: 'store' },
    { id: 'prohibited-actions', title: 'Qadağan Olunan Hərəkətlər', icon: 'ban' },
    { id: 'liability', title: 'Məsuliyyət', icon: 'balance' },
    { id: 'changes', title: 'Dəyişikliklər', icon: 'edit' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150;

      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const getIcon = (iconName) => {
    const icons = {
      info: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>,
      file: <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>,
      dollar: <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>,
      gavel: <path d="M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"/>,
      handshake: <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"/>,
      shield: <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>,
      cancel: <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>,
      store: <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"/>,
      ban: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"/>,
      balance: <path d="M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"/>,
      edit: <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    };
    return icons[iconName] || icons.info;
  };

  return (
    <div className="terms_page_wrapper">
      <div className="terms_container_main">
        <div className="terms_hero_section">
          <div className="terms_hero_icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
            </svg>
          </div>
          <h1 className="terms_main_title">İstifadə Şərtləri və Qaydalar</h1>
          <p className="terms_main_description">herracim.az platformasından istifadə qaydaları və şərtləri</p>
          <div className="terms_last_update">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            <span>Son yenilənmə: 15 Oktyabr 2024</span>
          </div>
        </div>

        <div className="terms_content_layout">
          <aside className="terms_sidebar_nav">
            <div className="terms_sidebar_sticky">
              <h3 className="terms_sidebar_title">Mündəricat</h3>
              <nav className="terms_toc_nav">
                {sections.map((section) => (
                  <button
                    key={section.id}
                    className={`terms_toc_item ${activeSection === section.id ? 'terms_toc_active' : ''}`}
                    onClick={() => scrollToSection(section.id)}
                  >
                    <svg className="terms_toc_icon" viewBox="0 0 24 24" fill="currentColor">
                      {getIcon(section.icon)}
                    </svg>
                    <span>{section.title}</span>
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          <main className="terms_main_content">
            {/* Introduction */}
            <section id="introduction" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('info')}
                  </svg>
                </div>
                <h2>Giriş</h2>
              </div>
              <div className="terms_section_content">
                <p>
                  herracim.az platformasından istifadə etməklə siz aşağıdakı şərt və qaydalara riayət etməyi 
                  qəbul edirsiniz. Bu sənəd platformamızın istifadə qaydalarını, məsuliyyətləri və 
                  bütün istifadəçilərin gözləməli olduğu şərtləri əhatə edir.
                </p>
                <div className="terms_important_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="8" x2="12" y2="12"/>
                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  <div>
                    <strong>Vacib:</strong>
                    <p>Platformadan istifadə etməklə bu şərtləri oxuduğunuzu və qəbul etdiyinizi təsdiq edirsiniz.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Terms of Use */}
            <section id="terms-of-use" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('file')}
                  </svg>
                </div>
                <h2>İstifadə Şərtləri</h2>
              </div>
              <div className="terms_section_content">
                <p>
                  Saytımızdan istifadə etməklə siz bu siyasətlərə razı olduğunuzu bildirirsiniz. 
                  Hər bir istifadəçi ədalətli, etik və qanuni hərəkət etməklə öhdəlik daşıyır.
                </p>
                <div className="terms_principles_grid">
                  <div className="terms_principle_card">
                    <div className="terms_principle_icon">✓</div>
                    <h4>Etik Davranış</h4>
                    <p>Bütün əməliyyatlarda dürüst və etik olmaq</p>
                  </div>
                  <div className="terms_principle_card">
                    <div className="terms_principle_icon">✓</div>
                    <h4>Qanuni Fəaliyyət</h4>
                    <p>Qanunlara və qaydalara riayət etmək</p>
                  </div>
                  <div className="terms_principle_card">
                    <div className="terms_principle_icon">✓</div>
                    <h4>Şəffaflıq</h4>
                    <p>Məhsul və xidmətlər haqqında düzgün məlumat vermək</p>
                  </div>
                  <div className="terms_principle_card">
                    <div className="terms_principle_icon">✓</div>
                    <h4>Hörmət</h4>
                    <p>Digər istifadəçilərə hörmətlə yanaşmaq</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Deposit Rules */}
            <section id="deposit-rules" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('dollar')}
                  </svg>
                </div>
                <h2>Təhlükəsizlik və Depozit Qaydaları</h2>
              </div>
              <div className="terms_section_content">
                <p>
                  Platformada təhlükəsizliyin təmin olunması və saxtakarlığın qarşısının alınması üçün 
                  aşağıdakı depozit siyasəti tətbiq olunur:
                </p>

                <h3>Təkliflər və Depozit Prosesi</h3>
                <ul className="terms_rules_list">
                  <li>İstifadəçi hərracda təklif etdikdə, sistem tərəfindən avtomatik olaraq depozit hesablanır</li>
                  <li>Depozit məbləği qiymətə uyğun olaraq avtomatik təyin olunur</li>
                  <li>Bu depozit sistem daxilində saxlanılır, satıcıya dərhal ötürülmür</li>
                </ul>

                <div className="terms_deposit_table">
                  <h4>Depozit məbləği cədvəli</h4>
                  <div className="terms_table_container">
                    <div className="terms_table_row terms_table_header">
                      <div className="terms_table_cell">Qiymət Aralığı</div>
                      <div className="terms_table_cell">Depozit Məbləği</div>
                    </div>
                    <div className="terms_table_row">
                      <div className="terms_table_cell"> 100 AZN</div>
                      <div className="terms_table_cell terms_highlight">5 AZN</div>
                    </div>
                    <div className="terms_table_row">
                      <div className="terms_table_cell"> 500 AZN</div>
                      <div className="terms_table_cell terms_highlight">10 AZN</div>
                    </div>
                    <div className="terms_table_row">
                      <div className="terms_table_cell"> 1000 AZN</div>
                      <div className="terms_table_cell terms_highlight">20 AZN</div>
                    </div>
                    <div className="terms_table_row">
                      <div className="terms_table_cell"> 5000 AZN</div>
                      <div className="terms_table_cell terms_highlight">50 AZN</div>
                    </div>
                    <div className="terms_table_row">
                      <div className="terms_table_cell">≥ 5000 AZN</div>
                      <div className="terms_table_cell terms_highlight">Artımlı hesablanır</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Auction Participation */}
            <section id="auction-participation" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('gavel')}
                  </svg>
                </div>
                <h2>Hərracda İştirak</h2>
              </div>
              <div className="terms_section_content">
                <p>Hərracda iştirak etmək üçün aşağıdakı qaydalar tətbiq edilir:</p>
                <ul className="terms_rules_list">
                  <li>Qeydiyyatdan keçmiş istifadəçilər hərraclarda iştirak edə bilər</li>
                  <li>Təklif verməzdən əvvəl balansda kifayət qədər depozit olmalıdır</li>
                  <li>Verilən təkliflər geri çəkilə bilməz</li>
                  <li>Hər təklif əvvəlki ən yüksək təklifdən artıq olmalıdır</li>
                  <li>Hərrac bitənə qədər istənilən sayda təklif verə bilərsiniz</li>
                </ul>
              </div>
            </section>

            {/* Meeting and Payment */}
            <section id="meeting-payment" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('handshake')}
                  </svg>
                </div>
                <h2>Görüş və Ödəniş Prosesi</h2>
              </div>
              <div className="terms_section_content">
                <div className="terms_process_timeline">
                  <div className="terms_timeline_item">
                    <div className="terms_timeline_number">1</div>
                    <div className="terms_timeline_content">
                      <h4>Qalibin Elanı</h4>
                      <p>Hərracın qalibi elan edildikdən sonra, alıcıya satıcının əlaqə məlumatları təqdim olunur</p>
                    </div>
                  </div>
                  <div className="terms_timeline_item">
                    <div className="terms_timeline_number">2</div>
                    <div className="terms_timeline_content">
                      <h4>Görüşün Təyin Edilməsi</h4>
                      <p>Alıcı satıcı ilə əlaqə yaradaraq real görüş təşkil edir</p>
                    </div>
                  </div>
                  <div className="terms_timeline_item">
                    <div className="terms_timeline_number">3</div>
                    <div className="terms_timeline_content">
                      <h4>Məhsulun Yoxlanması</h4>
                      <p>Real görüş zamanı tərəflər məhsulun vəziyyəti və şərtlər üzrə tam razılığa gəlir</p>
                    </div>
                  </div>
                  <div className="terms_timeline_item">
                    <div className="terms_timeline_number">4</div>
                    <div className="terms_timeline_content">
                      <h4>Depozit Ödənişi</h4>
                      <p>Alıcı satıcının istəyi ilə saytdakı "Depoziti Satıcıya Göndər" düyməsini təsdiqləyir</p>
                    </div>
                  </div>
                  <div className="terms_timeline_item">
                    <div className="terms_timeline_number">5</div>
                    <div className="terms_timeline_content">
                      <h4>Qalan Ödəniş</h4>
                      <p>Qalan məbləğ real görüş zamanı, məhsul alıcıya təhvil verilərkən ödənilir</p>
                    </div>
                  </div>
                </div>

                <div className="terms_warning_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                    <line x1="12" y1="9" x2="12" y2="13"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                  <div>
                    <strong>Diqqət:</strong>
                    <p>Platformadan kənarda heç bir ödəniş etməyin. Bütün əməliyyatlar sistem vasitəsilə aparılmalıdır.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Fake Listings */}
            <section id="fake-listings" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('shield')}
                  </svg>
                </div>
                <h2>Saxta Elanlara Qarşı Qoruma</h2>
              </div>
              <div className="terms_section_content">
                <p>Platformamız istifadəçilərin təhlükəsizliyini ön planda tutur:</p>

                <div className="terms_protection_grid">
                  <div className="terms_protection_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="15" y1="9" x2="9" y2="15"/>
                      <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                    <h4>Depozit Qorunması</h4>
                    <p>Heç bir satıcı hərrac davam edərkən depozit məbləğini əldə edə bilməz</p>
                  </div>
                  <div className="terms_protection_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
                    </svg>
                    <h4>Məhsul Yoxlanması</h4>
                    <p>Real görüş zamanı məhsulun elana uyğunluğu yoxlanılır</p>
                  </div>
                  <div className="terms_protection_card">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="8.5" cy="7" r="4"/>
                      <polyline points="17 11 19 13 23 9"/>
                    </svg>
                    <h4>Tam Geri Qaytarma</h4>
                    <p>Saxta elan olduqda depozit tam şəkildə alıcıya qaytarılır</p>
                  </div>
                </div>

                <div className="terms_fake_listing_criteria">
                  <h4>Elan saxta sayılır, əgər:</h4>
                  <ul>
                    <li>Məhsulun xüsusiyyətləri elanla fərqlidir</li>
                    <li>Məhsulun vəziyyəti təsvir olunduğu kimi deyil</li>
                    <li>Təqdim olunan şəkillər məhsula aid deyil</li>
                    <li>Məhsul əldə edilə bilməz vəziyyətdədir</li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Buyer Withdrawal */}
            <section id="buyer-withdrawal" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('cancel')}
                  </svg>
                </div>
                <h2>Alıcının Alışdan Çəkilməsi</h2>
              </div>
              <div className="terms_section_content">
                <div className="terms_rule_highlight">
                  <h4>Əsas Qayda:</h4>
                  <p>
                    Alıcı qalib olduqdan sonra məhsulu almaqdan imtina edərsə, depozit geri qaytarılmır və 
                    bu məbləğ satıcıya kompensasiya olaraq ötürülür.
                  </p>
                </div>

                <h4>Bu qaydanın məqsədi:</h4>
                <ul className="terms_purpose_list">
                  <li>Satıcıları zəmanətli hərrac prosesindən qorumaq</li>
                  <li>Ciddi və məsuliyyətli alıcıları təşviq etmək</li>
                  <li>Hərracın etibarlılığını təmin etmək</li>
                  <li>Vaxt itkisinin qarşısını almaq</li>
                </ul>

                <div className="terms_advice_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  <div>
                    <strong>Məsləhət:</strong>
                    <p>Təklif verməzdən əvvəl məhsul təsvirini diqqətlə oxuyun və məhsulu almaq istədiyinizdən əmin olun.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Seller Rules */}
            <section id="seller-rules" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('store')}
                  </svg>
                </div>
                <h2>Satıcılar üçün Qaydalar</h2>
              </div>
              <div className="terms_section_content">
                <div className="terms_seller_requirements">
                  <div className="terms_requirement_item">
                    <div className="terms_req_icon">1</div>
                    <div>
                      <h4>Düzgün Məlumat</h4>
                      <p>Məhsul haqqında düzgün və tam məlumat təqdim etmək məcburidir</p>
                    </div>
                  </div>
                  <div className="terms_requirement_item">
                    <div className="terms_req_icon">2</div>
                    <div>
                      <h4>Real Şəkillər</h4>
                      <p>Yalnız satılan məhsulun real şəkilləri istifadə olunmalıdır</p>
                    </div>
                  </div>
                  <div className="terms_requirement_item">
                    <div className="terms_req_icon">3</div>
                    <div>
                      <h4>Məhsulun Hazırlığı</h4>
                      <p>Məhsul satışa hazır vəziyyətdə olmalıdır</p>
                    </div>
                  </div>
                  <div className="terms_requirement_item">
                    <div className="terms_req_icon">4</div>
                    <div>
                      <h4>Əlaqə Saxlamaq</h4>
                      <p>Qalib alıcı ilə 24 saat ərzində əlaqə yaratmaq məcburidir</p>
                    </div>
                  </div>
                </div>

                <h4>Depozit ödənişi alınması:</h4>
                <div className="terms_deposit_flow">
                  <div className="terms_flow_step">
                    <span className="terms_step_badge">Addım 1</span>
                    <p>Qalib müəyyən edilir</p>
                  </div>
                  <div className="terms_flow_arrow">→</div>
                  <div className="terms_flow_step">
                    <span className="terms_step_badge">Addım 2</span>
                    <p>Real görüş baş verir</p>
                  </div>
                  <div className="terms_flow_arrow">→</div>
                  <div className="terms_flow_step">
                    <span className="terms_step_badge">Addım 3</span>
                    <p>Alıcı depoziti təsdiq edir</p>
                  </div>
                  <div className="terms_flow_arrow">→</div>
                  <div className="terms_flow_step">
                    <span className="terms_step_badge">Addım 4</span>
                    <p>Depozit satıcıya köçürülür (24 saat)</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Prohibited Actions */}
            <section id="prohibited-actions" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('ban')}
                  </svg>
                </div>
                <h2>Qadağan Olunan Hərəkətlər</h2>
              </div>
              <div className="terms_section_content">
                <p>Aşağıdakı hərəkətlər qəti şəkildə qadağandır və hesabın bloklanması ilə nəticələnə bilər:</p>

                <div className="terms_prohibited_grid">
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Saxta Məlumat</h4>
                    <p>Yalan və ya aldadıcı məlumat paylaşmaq</p>
                  </div>
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Qanunsuz Məhsullar</h4>
                    <p>Qeyri-qanuni məhsul və ya xidmətlər təklif etmək</p>
                  </div>
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Manipulyasiya</h4>
                    <p>Qiymətləri və ya hərracları manipulyasiya etmək</p>
                  </div>
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Çoxlu Hesab</h4>
                    <p>Eyni şəxsin çoxlu hesab yaratması</p>
                  </div>
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Spam və Reklam</h4>
                    <p>İcazəsiz reklam və spam mesajlar göndərmək</p>
                  </div>
                  <div className="terms_prohibited_item">
                    <div className="terms_prohibited_icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                      </svg>
                    </div>
                    <h4>Sistemin Suistimalı</h4>
                    <p>Platformanın zəifliklərindən istifadə etmək</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Liability */}
            <section id="liability" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('balance')}
                  </svg>
                </div>
                <h2>Məsuliyyət və Zəmanətlər</h2>
              </div>
              <div className="terms_section_content">
                <div className="terms_liability_sections">
                  <div className="terms_liability_section">
                    <h4>Platformanın Məsuliyyəti</h4>
                    <p>herracim.az vasitəçi platformadır və:</p>
                    <ul>
                      <li>İstifadəçilər arasında əlaqə yaradır</li>
                      <li>Təhlükəsiz ödəniş sistemi təqdim edir</li>
                      <li>Şikayətləri araşdırır və həll edir</li>
                      <li>Qaydaların pozulmasına qarşı tədbirlər görür</li>
                    </ul>
                  </div>

                  <div className="terms_liability_section">
                    <h4>Platformanın Məsuliyyəti Deyil</h4>
                    <p>herracim.az məsuliyyət daşımır:</p>
                    <ul>
                      <li>İstifadəçilərin real görüşlərində baş verən hadisələrə görə</li>
                      <li>Məhsulun keyfiyyəti və ya vəziyyətinə görə</li>
                      <li>İstifadəçilər arasında münaqişələrə görə (amma kömək edir)</li>
                      <li>Üçüncü tərəf xidmətlərinə görə</li>
                    </ul>
                  </div>

                  <div className="terms_liability_section">
                    <h4>İstifadəçinin Məsuliyyəti</h4>
                    <p>Hər bir istifadəçi məsuliyyət daşıyır:</p>
                    <ul>
                      <li>Təqdim etdiyi məlumatların düzgünlüyünə görə</li>
                      <li>Öz hərəkət və qərarlarına görə</li>
                      <li>Qaydaları nəzərə alıb yerinə yetirməyə görə</li>
                      <li>Digər istifadəçilərə hörmətlə yanaşmağa görə</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Changes */}
            <section id="changes" className="terms_section_block">
              <div className="terms_section_header">
                <div className="terms_section_icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    {getIcon('edit')}
                  </svg>
                </div>
                <h2>Şərtlərdə Dəyişikliklər</h2>
              </div>
              <div className="terms_section_content">
                <p>
                  herracim.az istifadə şərtlərini istənilən vaxt yeniləmək hüququnu özündə saxlayır. 
                  Əhəmiyyətli dəyişikliklər olduqda istifadəçilər email vasitəsilə və ya platformada 
                  bildiriş göndərməklə məlumatlandırılacaq.
                </p>
                <div className="terms_info_box">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="16" x2="12" y2="12"/>
                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                  </svg>
                  <div>
                    <strong>Qeyd:</strong>
                    <p>Dəyişikliklərdən sonra platformadan istifadə etməyiniz yeni şərtləri qəbul etdiyinizi göstərir.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Agreement Box */}
            {/* <div className="terms_agreement_box">
              <div className="terms_agreement_header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 11l3 3L22 4"/>
                  <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                </svg>
                <h3>Razılıq</h3>
              </div>
              <div className="terms_agreement_content">
                <p>
                  <strong>Saytdan istifadə etməklə siz bu istifadə şərtlərinə razılıq vermiş sayılırsınız.</strong>
                </p>
                <p>
                  Əgər bu şərtlərlə razı deyilsinizsə, platformadan istifadə etməməlisiniz. 
                  Suallarınız varsa, dəstək komandamızla əlaqə saxlayın.
                </p>
                <div className="terms_agreement_actions">
                  <label className="terms_checkbox_label">
                    <input
                      type="checkbox"
                      checked={agreementAccepted}
                      onChange={(e) => setAgreementAccepted(e.target.checked)}
                    />
                    <span className="terms_checkmark"></span>
                    <span>Mən bu şərtləri oxudum və qəbul edirəm</span>
                  </label>
                  <button 
                    className={`terms_accept_btn ${agreementAccepted ? 'terms_btn_enabled' : 'terms_btn_disabled'}`}
                    disabled={!agreementAccepted}
                  >
                    Davam Et
                  </button>
                </div>
              </div>
            </div> */}
          </main>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions;